import React, { useState, useEffect } from 'react'
import API from '../../utils/API'
import withNavigate from '../../components/common/withNavigate'
import { FormattedMessage } from 'react-intl';

function Verify(props) {
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')
  const [resendSuccess, setresendSuccess] = useState('')
  const [resendBtnEnable, setresendBtnEnable] = useState(false)

  const params = new URL(document.location.href).searchParams;
  const email = params.get("email");
  const passcode = params.get("passcode");

  const handleActivate = () => {
        API.verifyEmail(email, passcode)
        .then(res => {
          const { data } = res
          if (data.error) return setError(data.error)
          setSuccess(true);
          setError('');
        }).catch(err => {
          if(success === false){
            console.error(err)
            if(err.response && err.response.data && err.response.data == "PASSCODE_EXPIRED_OR_INVALID" ){
              setError(<FormattedMessage id="VERIFICATION_EMAIL_LINK_EXPIRED" values={{email: <b>{email}</b>}}/>);
            }else if (err.response && err.response.data){
              setError(<FormattedMessage id={err.response.data}/>);
            }
            else {
              setError(<FormattedMessage id="UNKNOWN_ERROR"/>);
            }
            setresendBtnEnable(true);
          }
        }
      )
  }


  useEffect(()=>{
    handleActivate()
  }, [])

  const resendVerificationEmail = (event) => {
    event.preventDefault()
    setresendBtnEnable(false);
    API.resendVerifyForCMSECreateAccount(email)
      .then(() => {
        console.log('Successfully resent to', email);
        setError('');   
        setresendSuccess(<FormattedMessage id="RESEND_VERIFICATION_EMAIL_SENT"/>); 
        setresendBtnEnable(true);  
    })
    .catch(err => {
      setError(err.message); 
      setresendSuccess('');
      setresendBtnEnable(true);
    })   
  }

  const handleDone = (event) => {
    event.preventDefault()
    window.location = '/login'
  }

  const logoutAndGoToLogin = (e) => {
    e.preventDefault();
    API.logout()
      .then(res => {
      }).catch(err => {
      }).finally(()=>{
        localStorage.removeItem('token');
        window.location = '/login'
      })
  }

  return (
    <div>
      <div className='password container py-5 h-100'>
        <div className='row d-flex justify-content-center p-3'>
          <div className='col-xl-4'>
            <form>
              <div className='header text-center mb-4'>
                <h2><FormattedMessage id="VERIFY_USER"/></h2>
              </div>
              <div className='card'>
                {success && 
                    <p>Your email has been successfully verified. You may now <a onClick={logoutAndGoToLogin} href="/login">login</a> to your account.</p>
                }

                {error ? <p className='error'>{error}</p> : null}
                {error &&
                  <button type='button' className='btn btn-primary btn-block' onClick={resendVerificationEmail} disabled={!resendBtnEnable}><FormattedMessage id="RESEND" /></button> 
                }   

                {resendSuccess ? <p className='form-lable text-center'>{resendSuccess}</p> : null}
                {resendSuccess &&
                  <button type='button' className='btn btn-primary btn-block' onClick={handleDone}><FormattedMessage id="DONE_BTN" /></button> 
                }             
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withNavigate(Verify)